export default __webpack_public_path__ + "static/aicase2-3adfda90957ea7543a0243cef9ec2d01.png";